package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.rememberApiClient
import co.maytes.standupbot.shared.dto.slack.ChannelMembersDto

class ChannelRosterStore(private val api: ApiClient) {
    var state: RosterPickerState by mutableStateOf(RosterPickerState.NoChannel)
        private set

    private var requestedChannelId: String? = null

    suspend fun load(workspaceId: String, channelId: String) {
        requestedChannelId = channelId
        state = RosterPickerState.Loading
        val result = api.get<ChannelMembersDto>("/api/v1/workspaces/$workspaceId/slack/channels/$channelId/members")
        if (requestedChannelId != channelId) return
        state =
            when (result) {
                is Result.Ok ->
                    RosterPickerState.Ready(
                        members = result.value.members,
                        truncated = result.value.truncated,
                        botIsMember = result.value.botIsMember,
                    )
                is Result.Err -> result.error.toRosterState()
            }
    }

    fun clear() {
        requestedChannelId = null
        state = RosterPickerState.NoChannel
    }
}

@Composable
fun rememberChannelRosterStore(): ChannelRosterStore {
    val api = rememberApiClient()
    return remember(api) { ChannelRosterStore(api) }
}
